import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ORDERS_V2_API_TOKEN } from '@epicuro-next/data/order-book';
import { selectQueryParams } from '@epicuro-next/state/router-store';
import { Store } from '@ngrx/store';
import { combineLatest, map, Observable, switchMap, take } from 'rxjs';

import { selectIsMultiAccountEnabled } from '../config/config.selectors';

export const detailPageAccountParam = 'od_accountId';

export function getOrderDetailParams(accountId: string | number) {
  return {
    [detailPageAccountParam]: accountId,
  };
}

export function OrderDetailsApiInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  const store = inject(Store);
  const ordersV2Url = inject(ORDERS_V2_API_TOKEN);

  // api/v2/orders/orderNumber
  const detailUrlRexExp = new RegExp(`${ordersV2Url}/\\w*`);
  const isOrderDetailsRequest =
    request.method === 'GET' &&
    request.url === (detailUrlRexExp.exec(request.url) ?? [])[0];
  const isExportOrderRequest = request.url.includes(`${ordersV2Url}/export`);

  if (isOrderDetailsRequest || isExportOrderRequest) {
    const isMultiAccountEnabled$ = store.select(selectIsMultiAccountEnabled);
    const accountId$: Observable<string | undefined> = store
      .select(selectQueryParams)
      .pipe(map((params) => params[detailPageAccountParam]));

    return combineLatest([isMultiAccountEnabled$, accountId$]).pipe(
      take(1),
      switchMap(([isMultiAccount, accountId]) => {
        if (isMultiAccount && accountId) {
          const headers = request.headers.set('Epc-Account-Id', `${accountId}`);
          return next(
            request.clone({
              headers,
            }),
          );
        }

        return next(request);
      }),
    );
  }

  return next(request);
}
